
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
    name: 'RoltekLogo',
})
export default class RoltekHeaderLogo extends Vue {
    @Prop({ default: '100' }) private height?: string;
}
